export default __webpack_public_path__ + "static/media/warn.c35e11ec.svg";